import { addDays, endOfDay } from "date-fns";

export const twoWeeksDown = from => endOfDay(addDays(from, 14));
